import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ChangeService {

  public entityChangedSubject: Subject<void> = new Subject<void>();

}
